import React from 'react';
import { bankHolidays, openingHours } from '../OpeningHours';

const currentDate = new Date();
const currentWeekday = currentDate.toLocaleString('en-UK', { weekday: 'long' });
const currentTime = currentDate.getTime();

const isDateBankHoliday = bankHolidays();

const todayOpeningTime = openingHours[currentWeekday].open;
const todayClosingTime = openingHours[currentWeekday].close;

const isOpeningToday = todayOpeningTime !== '';
const isClosingToday = todayClosingTime !== '';

let companyOpenStatusMessage: string;

// Check if time now is before opening time
const openingTime = new Date();
const openingTimeParts = todayOpeningTime.split(':');
let openingHour = parseInt(openingTimeParts[0]);
if (isOpeningToday) {
    if (openingTimeParts[1].toLowerCase().includes('pm') && openingHour < 12) {
        openingHour += 12;
    }
}
openingTime.setHours(openingHour, parseInt(openingTimeParts[1]));
const isBeforeOpeningTime = currentTime < openingTime.getTime();

// Check if time now is after closing time
const closingTime = new Date();
const closingTimeParts = todayClosingTime.split(':');
let closingHour = parseInt(closingTimeParts[0]);
if (isClosingToday) {
    if (closingTimeParts[1].toLowerCase().includes('pm') && closingHour < 12) {
        closingHour += 12;
    }
}
closingTime.setHours(closingHour, parseInt(closingTimeParts[1]));
const isAfterClosingTime = currentTime > closingTime.getTime();
const isOpenNow = !isDateBankHoliday(currentDate) && isOpeningToday && !isBeforeOpeningTime && !isAfterClosingTime;


// Find the next opening day
let nextOpeningDay: string;
let nextOpeningTime: string;
const nextHolidayDateCheck = new Date();

const daysOfWeek = Object.keys(openingHours);
const currentIndex = daysOfWeek.indexOf(currentWeekday);
let nextDayIndex = currentIndex + 1;
while (true) {
    const nextDay = daysOfWeek[nextDayIndex % daysOfWeek.length];
    nextHolidayDateCheck.setDate(nextHolidayDateCheck.getDate() + 1);
    if (!isDateBankHoliday(nextHolidayDateCheck) && openingHours[nextDay].open !== '') {
        nextOpeningDay = nextDay;
        nextOpeningTime = openingHours[nextDay].open;
        break;
    }
    nextDayIndex++;
}

// Company Open status logic
if (isDateBankHoliday(currentDate)) { //Today has opening hours and not bank holiday
    companyOpenStatusMessage = 'We are closed due bank holiday. Opening ' + nextOpeningDay + ' ' + nextOpeningTime;
} else if (isOpeningToday) {

    if (isBeforeOpeningTime) {
        companyOpenStatusMessage = 'We are closed. Opening today ' + todayOpeningTime; // before opening time
    } else {
        if (isAfterClosingTime) {
            companyOpenStatusMessage = 'We are closed. Opening ' + nextOpeningDay + ' ' + nextOpeningTime;; // after opening time | after closing time
        } else {
            companyOpenStatusMessage = 'We are open until ' + todayClosingTime; // after opening time | before closing time
        }
    }
} else {
    companyOpenStatusMessage = 'We are closed. Opening ' + nextOpeningDay + ' ' + nextOpeningTime;
}

export default function WeAreOpenUntil(props: any) {
    const { stylingRegion } = props;
    return (
        <div className="open-until">
            {isOpenNow && (
                <div>
                    <span className="open-icon open">
                        OPEN NOW
                    </span>
                </div>
            )}
            <div className={`${stylingRegion}-open-until-title`}>
                {companyOpenStatusMessage}
            </div>
        </div>
    );
}